import { render, staticRenderFns } from "./GroupList.vue?vue&type=template&id=b538ab4e&scoped=true&"
import script from "./GroupList.vue?vue&type=script&lang=ts&"
export * from "./GroupList.vue?vue&type=script&lang=ts&"
import style0 from "./GroupList.vue?vue&type=style&index=0&id=b538ab4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b538ab4e",
  null
  
)

export default component.exports